/** Settings page structure for client-facing account areas. */

export const SETTINGS_PAGE_TEST_ID = 'settings-page';
export const SETTINGS_LANGUAGE_SECTION_TEST_ID = 'settings-language-section';
export const SETTINGS_PRIVACY_SECTION_TEST_ID = 'settings-privacy-section';
export const SETTINGS_HELP_SECTION_TEST_ID = 'settings-help-section';

export const SETTINGS_CLIENT_PREMIUM_TEST_ID = 'settings-client-premium-section';

export const SETTINGS_NAV_ITEMS = [
  { id: 'profile', labelKey: 'settings.tab_profile', defaultLabel: 'Profile', testId: 'settings-tab-profile' },
  { id: 'notifications', labelKey: 'settings.tab_notifications', defaultLabel: 'Notifications', testId: 'settings-tab-notifications' },
  { id: 'preferences', labelKey: 'settings.tab_preferences', defaultLabel: 'Preferences', testId: 'settings-tab-preferences' },
  { id: 'experience', labelKey: 'settings.tab_experience', defaultLabel: 'Experience', testId: 'settings-tab-experience' },
  { id: 'privacy', labelKey: 'settings.tab_privacy', defaultLabel: 'Privacy & Data', testId: 'settings-tab-privacy' },
  { id: 'help', labelKey: 'settings.tab_help', defaultLabel: 'Help & Support', testId: 'settings-tab-help' },
  { id: 'subscription', labelKey: 'settings.tab_subscription', defaultLabel: 'Subscription', testId: 'settings-tab-subscription' },
];

export const SETTINGS_HELP_LINKS = [
  { href: '/faq', labelKey: 'settings.help_faq_link', defaultLabel: 'Help / FAQ', testId: 'settings-help-faq-link' },
  { href: '/contact', labelKey: 'settings.help_contact_link', defaultLabel: 'Contact support', testId: 'settings-help-contact-link' },
];

export function settingsNavItemIds() {
  return SETTINGS_NAV_ITEMS.map((item) => item.id);
}
